import { render, staticRenderFns } from "./create-edit-shift.vue?vue&type=template&id=1ce8e24e&scoped=true&lang=pug"
import script from "./create-edit-shift.vue?vue&type=script&lang=ts"
export * from "./create-edit-shift.vue?vue&type=script&lang=ts"
import style0 from "./create-edit-shift.vue?vue&type=style&index=0&id=1ce8e24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce8e24e",
  null
  
)

export default component.exports